import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { toUpper } from "lodash";

@Component({
  selector: "app-trucks-add",
  templateUrl: "./trucks-add.component.html",
  styleUrls: ["./trucks-add.component.css"],
})
export class TrucksAddComponent implements OnInit {
  truckAddFrom!: FormGroup;
  token: any;
  file: any = "";
  truckImage: any = "";
  vehicleRC: any = "";
  RCImageName: any;
  permitImageName: any;
  fitnessImageName: any;
  pollutionImageName: any;
  insuranceImageName: any;
  profileImg: boolean = true;
  uploadVehicle: boolean = true;
  uploadPermit: boolean = true;
  uploadFitness: boolean = true;
  uploadPollution: boolean = true;
  uploadInsurance: boolean = true;
  truckCategory: any = [];
  truckTypeList: any = [];
  truckOwner: any = [];
  date = new FormControl(new Date());
  serializedDate = new FormControl(new Date().toISOString());
  today: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  RCImage: any;
  permitImage: any;
  fitnessImage: any;
  pollutionImage: any;
  insuranceImage: any;
  truck_documents_proofs: any = [];
  selectCatgValue: any;
  loading: boolean = false;
  truckType: any = "-1";
  truckNumber: any = -1;
  truckImageloading: boolean = false;
  rcLoading: boolean = false;
  permitLoading: boolean = false;
  fitnessLoading: boolean = false;
  pollutionLoading: boolean = false;
  insuranceLoading: boolean = false;
  isRcVerifying: boolean = false;
  isRcVerified: boolean = false;
  rcVerificationData: any = null;
  autoPopulatedFields: { [key: string]: boolean } = {};

  public isFieldRestricted(fieldName: string): boolean {
    return this.isRcVerified && !!this.autoPopulatedFields[fieldName];
  }

  public resetRcVerification(): void {
    this.isRcVerified = false;
    this.rcVerificationData = null;
    this.autoPopulatedFields = {};
  }

  constructor(
    private formBuilder: FormBuilder,
    private services: TruckOwnerService,
    private matdialogref: MatDialogRef<TrucksAddComponent>,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}


  onTruckNumberChange(value: string) {
    const sanitizedValue = (value || "").replace(/[^a-zA-Z0-9]/g, "").toUpperCase().trim();
    this.truckAddFrom.patchValue({ truck_number: sanitizedValue });
    if (this.isRcVerified) {
      this.resetRcVerification();
    }
  }

  public verifyVehicleRC(): void {
    const rawNumber = this.truckAddFrom.value.truck_number;
    if (!rawNumber) {
      this.snackBar.open("Please enter Truck Number to verify", "OK", {
        duration: 4000,
      });
      this.truckAddFrom.controls["truck_number"].markAsTouched();
      return;
    }

    const cleanNumber = rawNumber.replace(/[^A-Z0-9]/gi, "").trim().toUpperCase();
    this.isRcVerifying = true;

    this.services.verifyVehicleRC(cleanNumber, this.token).subscribe({
      next: (response: any) => {
        this.isRcVerifying = false;
        let resData = response.body?.data || response.body;
        while (resData?.data && typeof resData.data === "object" && !resData.response) {
          resData = resData.data;
        }

        if (resData?.error === "true" || resData?.code === "400") {
          this.snackBar.open(resData.message || "Invalid Vehicle Number format.", "Fail", {
            duration: 5000,
          });
          this.isRcVerified = false;
          return;
        }

        const firstResp = Array.isArray(resData?.response) ? resData.response[0] : resData?.response;
        const innerResp = firstResp?.response || firstResp;
        const vahan = this.parseVahanResponse(innerResp);

        if (!vahan || vahan.status?.toLowerCase().includes("fail") || !vahan.truck_number) {
          this.snackBar.open("Vehicle details not found in VAHAN National Registry.", "Fail", {
            duration: 5000,
          });
          this.isRcVerified = false;
          return;
        }

        this.isRcVerified = true;
        this.rcVerificationData = vahan;
        this.autoPopulatedFields = {};
        this.autoPopulatedFields['truck_number'] = true;

        // Auto-fill Make Name (Manufacturer)
        if (vahan.make_name && !/^[\*\s]+$/.test(vahan.make_name)) {
          this.truckAddFrom.patchValue({ make_name: vahan.make_name.trim() });
          this.autoPopulatedFields['make_name'] = true;
        }

        // Auto-fill Truck Model
        if (vahan.truck_model && !/^[\*\s]+$/.test(vahan.truck_model)) {
          this.truckAddFrom.patchValue({ truck_model: vahan.truck_model.trim() });
          this.autoPopulatedFields['truck_model'] = true;
        }

        // Auto-fill Manufacture Year
        const mYear = this.extractManufactureYear(vahan.manufacture_year);
        if (mYear) {
          this.truckAddFrom.patchValue({ manufacture_year: mYear });
          this.autoPopulatedFields['manufacture_year'] = true;
        }

        // Auto-fill RC Valid Date
        const rcValidDate = this.parseVahanDate(vahan.rc_valid);
        if (rcValidDate) {
          this.truckAddFrom.patchValue({ rc_valid: rcValidDate });
          this.truckAddFrom.patchValue({ vehicle_rc_expiry: rcValidDate });
          this.autoPopulatedFields['rc_valid'] = true;
          this.autoPopulatedFields['vehicle_rc_expiry'] = true;
        }

        // Auto-fill Fitness Expiry Date
        const fitnessDate = this.parseVahanDate(vahan.fitness_expiry);
        if (fitnessDate) {
          this.truckAddFrom.patchValue({ fitness_expiry: fitnessDate });
          this.autoPopulatedFields['fitness_expiry'] = true;
        }

        // Auto-fill Insurance Expiry Date
        const insuranceDate = this.parseVahanDate(vahan.insurance_expiry);
        if (insuranceDate) {
          this.truckAddFrom.patchValue({ insurance_expiry: insuranceDate });
          this.autoPopulatedFields['insurance_expiry'] = true;
        }

        // Auto-fill Pollution / PUCC Expiry Date
        const pollutionDate = this.parseVahanDate(vahan.pollution_expiry);
        if (pollutionDate) {
          this.truckAddFrom.patchValue({ pollution_expiry: pollutionDate });
          this.autoPopulatedFields['pollution_expiry'] = true;
        }

        // Auto-fill Permit Expiry Date if available
        const permitDate = this.parseVahanDate(vahan.permit_expiry);
        if (permitDate) {
          this.truckAddFrom.patchValue({ permit_type_expiry: permitDate });
          this.autoPopulatedFields['permit_type_expiry'] = true;
        }

        // Auto-fill Home Location from RTO registration place if not already set
        if (vahan.registered_at && !this.truckAddFrom.value.home_location) {
          this.truckAddFrom.patchValue({ home_location: vahan.registered_at.trim() });
          this.autoPopulatedFields['home_location'] = true;
        }

        this.snackBar.open("Vehicle RC verified successfully via VAHAN!", "Success", {
          duration: 5000,
        });
      },
      error: (error: any) => {
        this.isRcVerifying = false;
        this.isRcVerified = false;
        if (["jwt malformed", "jwt expired", "invalid signature"].includes(error.error?.message)) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        const errorMsg =
          error.error?.error?.message ||
          error.error?.message ||
          error.message ||
          "Failed to verify Vehicle RC.";
        this.snackBar.open(errorMsg, "Fail", { duration: 5000 });
      },
    });
  }

  private parseVahanResponse(resp: any): any {
    if (!resp) return null;

    if (typeof resp === "string" && resp.includes("<VehicleDetails>")) {
      try {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(resp, "text/xml");
        const getVal = (tag: string) => {
          const el = xmlDoc.getElementsByTagName(tag)[0];
          return el ? (el.textContent || "").trim() : "";
        };

        return {
          truck_number: getVal("rc_regn_no"),
          make_name: getVal("rc_maker_desc"),
          truck_model: getVal("rc_maker_model"),
          manufacture_year: getVal("rc_manu_month_yr"),
          fitness_expiry: getVal("rc_fit_upto"),
          insurance_expiry: getVal("rc_insurance_upto"),
          rc_valid: getVal("rc_fit_upto") || getVal("rc_regn_dt"),
          vehicle_class: getVal("rc_vh_class_desc") || getVal("rc_vhclass_desc"),
          category: getVal("rc_vch_catg"),
          gvw: getVal("rc_gvw"),
          unladen_weight: getVal("rc_unld_wt"),
          fuel: getVal("rc_fuel_desc"),
          body_type: getVal("rc_body_type_desc"),
          financer: getVal("rc_financer"),
          pollution_expiry: getVal("rc_pucc_upto"),
          permit_expiry: getVal("rc_permit_valid_upto") || getVal("rc_np_upto"),
          registered_at: getVal("rc_registered_at"),
          owner_name: getVal("rc_owner_name"),
          insurance_company: getVal("rc_insurance_comp"),
          insurance_policy: getVal("rc_insurance_policy_no"),
          status: getVal("rc_status") || getVal("stautsMessage") || "Active",
        };
      } catch (e) {
        console.error("Error parsing VAHAN XML:", e);
      }
    }

    if (typeof resp === "object") {
      return {
        truck_number: resp.rc_regn_no || resp.vehiclenumber || resp.rcNumber || resp.truck_number || "",
        make_name: resp.rc_maker_desc || resp.maker || resp.make || "",
        truck_model: resp.rc_maker_model || resp.model || resp.truck_model || "",
        manufacture_year: resp.rc_manu_month_yr || resp.manufacturingDate || resp.manufacture_year || "",
        fitness_expiry: resp.rc_fit_upto || resp.fitnessUpto || "",
        insurance_expiry: resp.rc_insurance_upto || resp.insuranceUpto || "",
        rc_valid: resp.rc_fit_upto || resp.rc_regn_dt || resp.regnDate || "",
        vehicle_class: resp.rc_vh_class_desc || resp.rc_vhclass_desc || resp.vehicleClass || "",
        category: resp.rc_vch_catg || "",
        gvw: resp.rc_gvw || resp.gvw || "",
        unladen_weight: resp.rc_unld_wt || resp.unladenWeight || "",
        fuel: resp.rc_fuel_desc || resp.fuelType || "",
        body_type: resp.rc_body_type_desc || "",
        financer: resp.rc_financer || "",
        pollution_expiry: resp.rc_pucc_upto || "",
        permit_expiry: resp.rc_permit_valid_upto || resp.rc_np_upto || "",
        registered_at: resp.rc_registered_at || "",
        owner_name: resp.rc_owner_name || resp.ownerName || "",
        insurance_company: resp.rc_insurance_comp || "",
        insurance_policy: resp.rc_insurance_policy_no || "",
        status: resp.rc_status || resp.stautsMessage || resp.status || "Active",
      };
    }

    return null;
  }

  private parseVahanDate(dateStr: string): Date | null {
    if (!dateStr || dateStr.includes("*") || dateStr.toUpperCase() === "NA") {
      return null;
    }
    const cleanStr = dateStr.trim();

    // Check DD-Mon-YYYY or DD-Month-YYYY (e.g. 15-Oct-2025, 24-SEP-2026)
    const monMatch = cleanStr.match(/^(\d{1,2})[-/ ]([A-Za-z]{3,9})[-/ ](\d{4})$/);
    if (monMatch) {
      const d = new Date(cleanStr);
      if (!isNaN(d.getTime())) return d;
    }

    // Check DD/MM/YYYY or DD-MM-YYYY (e.g. 24/09/2026, 05-11-2025)
    const dmyMatch = cleanStr.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
    if (dmyMatch) {
      const day = parseInt(dmyMatch[1], 10);
      const month = parseInt(dmyMatch[2], 10) - 1;
      const year = parseInt(dmyMatch[3], 10);
      const d = new Date(year, month, day);
      if (!isNaN(d.getTime())) return d;
    }

    // Check YYYY-MM-DD or YYYY/MM/DD (e.g. 2026-09-24)
    const ymdMatch = cleanStr.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
    if (ymdMatch) {
      const year = parseInt(ymdMatch[1], 10);
      const month = parseInt(ymdMatch[2], 10) - 1;
      const day = parseInt(ymdMatch[3], 10);
      const d = new Date(year, month, day);
      if (!isNaN(d.getTime())) return d;
    }

    const fallbackDate = new Date(cleanStr);
    return !isNaN(fallbackDate.getTime()) ? fallbackDate : null;
  }

  private extractManufactureYear(val: string): number | null {
    if (!val) return null;
    const match = String(val).match(/\b(19\d{2}|20\d{2})\b/);
    return match ? parseInt(match[0], 10) : null;
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.GetCategory();
    this.getTrucks();
    this.truckAddFrom = this.formBuilder.group({
      truck_number: [
        "",
        Validators.compose([
          Validators.pattern("^[A-Z0-9]+$"),
          Validators.minLength(6),
          Validators.maxLength(10),
        ]),
      ],
      rc_valid: [""],
      home_location: [""],
      make_name: [""],
      truck_model: [""],
      manufacture_year: [""],
      truck_category: ["", [Validators.required]],
      truck_type: ["", [Validators.required]],
      truck_image: [""],
      vehicle_rc_expiry: [""],
      vehicle_rc: [""],
      permit_type_expiry: [""],
      permit_type: [""],
      fitness_expiry: [""],
      firness: [""],
      pollution_expiry: [""],
      pollution: [""],
      insurance_expiry: [""],
      insurance: [""],
    });
  }
  onChange(event: any, type: any): void {
    this.file = event.target.files[0];
    if (type == "Truck") {
      this.truckImageloading = true;
    }
    if (type == "RC") {
      this.rcLoading = true;
    }
    if (type == "PermitType") {
      this.permitLoading = true;
    }
    if (type == "Fitness") {
      this.fitnessLoading = true;
    }
    if (type == "Pollution") {
      this.pollutionLoading = true;
    }
    if (type == "Insurance") {
      this.insuranceLoading = true;
    }
    this.services.uploadImage(this.file).subscribe((response: any) => {
      if (response.status === 201) {
        this.truckImageloading = false;
        this.rcLoading = false;
        this.permitLoading = false;
        this.fitnessLoading = false;
        this.pollutionLoading = false;
        this.insuranceLoading = false;
        var truckImg = this.file.type.split("/");
        if (
          type == "Truck" &&
          (truckImg[1] === "pdf" ||
            truckImg[1] === ".jpg" ||
            truckImg[1] === "png" ||
            truckImg[1] === "jpeg")
        ) {
          this.profileImg = false;
          this.truckImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        var imgType = this.file.type.split("/");

        if (
          type == "RC" &&
          (imgType[1] === "pdf" ||
            imgType[1] === ".jpg" ||
            imgType[1] === "png" ||
            imgType[1] === "jpeg")
        ) {
          this.uploadVehicle = false;
          this.RCImageName = this.file.name.slice(0, 11);
          this.RCImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        var imgPermitType = this.file.type.split("/");

        if (
          type == "PermitType" &&
          (imgPermitType[1] === "pdf" ||
            imgPermitType[1] === ".jpg" ||
            imgPermitType[1] === "png" ||
            imgPermitType[1] === "jpeg")
        ) {
          this.uploadPermit = false;
          this.permitImageName = this.file.name.slice(0, 11);
          this.permitImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        var imgFitnessType = this.file.type.split("/");

        if (
          type == "Fitness" &&
          (imgFitnessType[1] === "pdf" ||
            imgFitnessType[1] === ".jpg" ||
            imgFitnessType[1] === "png" ||
            imgFitnessType[1] === "jpeg")
        ) {
          this.uploadFitness = false;
          this.fitnessImageName = this.file.name.slice(0, 11);
          this.fitnessImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        var imgPollutionType = this.file.type.split("/");

        if (
          type == "Pollution" &&
          (imgPollutionType[1] === "pdf" ||
            imgPollutionType[1] === ".jpg" ||
            imgPollutionType[1] === "png" ||
            imgPollutionType[1] === "jpeg")
        ) {
          this.uploadPollution = false;
          this.pollutionImageName = this.file.name.slice(0, 11);
          this.pollutionImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
        var imgInsuranceType = this.file.type.split("/");

        if (
          type == "Insurance" &&
          (imgInsuranceType[1] === "pdf" ||
            imgInsuranceType[1] === ".jpg" ||
            imgInsuranceType[1] === "png" ||
            imgInsuranceType[1] === "jpeg")
        ) {
          this.uploadInsurance = false;
          this.insuranceImageName = this.file.name.slice(0, 11);
          this.insuranceImage = response.body.image_link;
          this.snackBar.open("File Added Successfully", "Success", {
            duration: 5000,
          });
          return;
        } else {
          this.snackBar.open(
            "Please upload only JPG or PNG or PDF type file",
            "Fail",
            {
              duration: 5000,
            }
          );
        }
      } else {
        this.truckImageloading = false;
        this.rcLoading = false;
        this.permitLoading = false;
        this.fitnessLoading = false;
        this.pollutionLoading = false;
        this.insuranceLoading = false;
        this.snackBar.open(response?.body?.message || "File upload failed", "Fail", {
          duration: 5000,
        });
      }
    },
    (error: any) => {
      this.truckImageloading = false;
      this.rcLoading = false;
      this.permitLoading = false;
      this.fitnessLoading = false;
      this.pollutionLoading = false;
      this.insuranceLoading = false;
      const msg =
        (typeof error?.error === "string" && error.error) ||
        error?.error?.message ||
        error?.message ||
        "Failed to upload file";
      this.snackBar.open(msg, "Fail", { duration: 5000 });
    });
  }
  addTruck(event?: any) {
    if (!this.truckAddFrom.valid || this.loading) {
      this.truckAddFrom.markAllAsTouched();
      return;
    }
    const button: HTMLButtonElement | null =
      (event?.currentTarget as HTMLButtonElement) ||
      ((event?.target as HTMLElement)?.closest('button') as HTMLButtonElement) ||
      (event?.target as HTMLButtonElement);

    const enableButton = () => {
      this.loading = false;
      if (button) {
        button.disabled = false;
      }
    };

    this.loading = true;
    if (button) {
      button.disabled = true;
    }

    const rawTruck = this.truckAddFrom.getRawValue();
    this.truck_documents_proofs = {
      vehicle_rc: this.RCImage,
      vehicle_rc_expiry: rawTruck.vehicle_rc_expiry,
      permit_type: this.permitImage,
      permit_type_expiry: rawTruck.permit_type_expiry,
      fitness: this.fitnessImage,
      fitness_expiry: rawTruck.fitness_expiry,
      pollution: this.pollutionImage,
      pollution_expiry: rawTruck.pollution_expiry,
      insurance: this.insuranceImage,
      insurance_expiry: rawTruck.insurance_expiry,
      rc_verified: !!this.isRcVerified,
      is_rc_verified: !!this.isRcVerified,
    };
    if (rawTruck.manufacture_year > new Date().getFullYear()) {
      enableButton();
      this.snackBar.open(
        "Manufacture year should be less than current year",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    const truckObj = {
      truck_number: toUpper(rawTruck.truck_number),
      rc_valid: rawTruck.rc_valid || rawTruck.vehicle_rc_expiry,
      home_location: rawTruck.home_location,
      make_name: rawTruck.make_name,
      truck_model: rawTruck.truck_model,
      manufacture_year: rawTruck.manufacture_year,
      truck_image: this.truckImage,
      truck_category: rawTruck.truck_category,
      truck_type: rawTruck.truck_type,
      truck_documents_proofs: this.truck_documents_proofs,
      rc_verified: !!this.isRcVerified,
      is_rc_verified: !!this.isRcVerified,
    };

    if (truckObj.truck_image == "") {
      enableButton();
      this.snackBar.open("Please upload truck image", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.loading = true;

    this.services.AddTruck(truckObj, this.token).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.snackBar.open("Truck added successfully", "Success", {
            duration: 5000,
          });
          this.loading = false;
          window.location.reload();
          this.getTrucks();
          this.matdialogref.close();
        } else {
          enableButton();
          const message =
            response?.body?.message ||
            response?.message ||
            "Failed to add truck";
          this.snackBar.open(message, "Fail", {
            duration: 5000,
          });
        }
        setTimeout(() => {
          enableButton();
        }, 500);
      },
      (error) => {
        enableButton();

        const errorMessage =
          (typeof error?.error === "string" && error.error) ||
          error?.error?.message ||
          error?.error?.data ||
          error?.message ||
          "Failed to add truck";

        if (
          errorMessage === "jwt malformed" ||
          errorMessage === "jwt expired" ||
          errorMessage === "invalid signature"
        ) {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(errorMessage, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  removeImg(event: any, type: any) {
    if (type == "Truck") {
      this.profileImg = true;
      this.truckImage = "";
    }
    if (type == "RC") {
      this.uploadVehicle = true;
    }
    if (type == "permit") {
      this.uploadPermit = true;
    }
    if (type == "fitness") {
      this.uploadFitness = true;
    }
    if (type == "pollution") {
      this.uploadPollution = true;
    }
    if (type == "insurance") {
      this.uploadInsurance = true;
    }
  }
  close() {
    this.matdialogref.close();
  }

  public gettruckCatg(item: any) {
    this.selectCatgValue = item.value;
    this.services.GetTypeTruck(this.selectCatgValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
          if (this.truckTypeList.length === 0) {
            this.snackBar.open("No truck types found for this category", "Fail", {
              duration: 5000,
            });
          }
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public GetCategory() {
    this.services.GetCategory().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckCategory = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  getTrucks() {
    this.services
      .getTrucks(this.token, this.truckType, this.truckNumber)
      .subscribe(
        (response: any) => {},
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
